import { render, staticRenderFns } from "./OutboundDocumentFilesTab.vue?vue&type=template&id=77b9affe"
import script from "./OutboundDocumentFilesTab.vue?vue&type=script&lang=js"
export * from "./OutboundDocumentFilesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports